import React from "react";
import styles from "./ContactInfo.module.css";
import { TfiLocationPin } from "react-icons/tfi";
import { BsCalendarWeek, BsPerson } from "react-icons/bs";
import { ImMobile } from "react-icons/im";
import { MdOutlineEmail } from "react-icons/md";




export default function ContactInfoOne({when, where, mobile, who, email}) {

    return(
        <div className={styles.infoBoxWrapper}>
            <div className={styles.infoBox}>
                {when && (<div className={styles.info}>
                    <BsCalendarWeek className={styles.icon}/>
                    <p className={styles.value}>{when}</p>
                </div>)}
                {where && (<div className={styles.info}>
                    <TfiLocationPin className={styles.icon}/>
                    <p className={styles.value}>{where}</p>
                </div>)}
                {who && (<div className={styles.info} style={{ gridColumn: 2}}>
                    <BsPerson className={styles.icon}/>
                    <p className={styles.value}>{who}</p>
                </div>)}
                {mobile &&(<div className={styles.info}>
                    <ImMobile className={styles.icon}/>
                    <p className={styles.value}>{mobile}</p>
                </div>)}
                {email &&(<div className={styles.info}>
                    <MdOutlineEmail className={styles.icon}/>
                    <p className={styles.value}>{email}</p>
                </div>)}
            </div>
        </div>
    );
}